function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKPATH opcode — verify routing path from authority root.
 */

module.exports = {
  name: 'CHECKPATH',
  description: 'Verify a routing capability path provided at unlock time, starting from a claimed authority root and bound to a static hash.',
  exampleScript: {
    op: 'CHECKPATH',
    publickey: '<publickey>',
    hash: '<hash (optional)>',
    witness: {
      hops: [{
        to: '<publickey>',
        value: '<base64_json_payload>',
        sig: '<signature>'
      }]
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.verifyRoutingPath !== 'function') {
      return false;
    }
    var start_publickey = node.publickey;
    if (typeof start_publickey !== 'string' || start_publickey.length === 0) {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var path = witness.hops;
    if (!Array.isArray(path) || path.length === 0) {
      return false;
    }
    var binding_hash = typeof node.hash === 'string' ? node.hash : '';
    return context.app.crypto.verifyRoutingPath(path, start_publickey, binding_hash) === true;
  }
};